import { useCallback } from 'react';
import { matchEmailDomain } from '../../common/utils/auth.utils';
import { useCarrefourOIDC } from './useCarrefourOIDC';

interface UseOIDCResponse {
  startOIDC: (email: string, forceLogin?: boolean) => { matched: boolean };
}

export const SUPPORTED_DOMAINS = ['carrefour.com'];

export function useOIDC(): UseOIDCResponse {
  const { startProcess: startCarrefourProcess } = useCarrefourOIDC();

  const startOIDC = useCallback((email: string, forceLogin?: boolean) => {
    const matchingDomain = SUPPORTED_DOMAINS.find((domain) => matchEmailDomain(email, domain));
    let matched = true;

    switch (matchingDomain) {
      case 'carrefour.com':
        startCarrefourProcess(email, forceLogin);
        break;
      default:
        matched = false;
    }

    return {
      matched,
    };
  }, []);

  return {
    startOIDC,
  };
}
